import { authAxios, BASE_URL } from './axios';

export const getFiles = async ({ params }) => {
  const res = await authAxios.get(BASE_URL + '/v1/rest/pluxity/vsc/010/files', { params });
  return res.data;
};

export const postFiles = async (formData) => {
  const res = await authAxios.post(BASE_URL + '/v1/rest/pluxity/vsc/020/files', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const deleteFiles = async (data) => {
  const res = await authAxios.delete(BASE_URL + '/v1/rest/pluxity/vsc/030/files', { data });
  return res.data;
};
